const PopupSceneType = { // 弹窗出现场景
  None: 0,
  PrivacyPolicy: 1, // 隐私协议
  ChangeLanguage: 2, // 切换语言
};

const AgreementType = { // 弹窗出现场景
  PrivacyPolicy: '2', // 隐私政策
  UserAgreement: '1', // 用户协议
};

const PopupLanguageScene = {
  home: 1
};
export {
  PopupSceneType,
  AgreementType,
  PopupLanguageScene
};
